export const routineMailDimensions = {
  'operational-domain': 'Topic', 'matter-type': 'Sub-topic',
  'priority-risk': 'Urgency', 'workflow-recommendation': 'Next step',
} as const;
export type MailContextValue = {dimension:string;canonical_code:string;name:string;representation:string};
export function routineMailContext(values:MailContextValue[] = []) {
  return Object.entries(routineMailDimensions).map(([dimension,label]) => {
    const current = values.filter(v => v.dimension === dimension && ['Published canonical','Rule-applied canonical'].includes(v.representation));
    const distinct = [...new Map(current.map(v => [v.canonical_code,v])).values()];
    return {dimension,label,value:distinct.length>1?'Conflicting values — review':distinct[0]?.name??'Not set',conflict:distinct.length>1};
  });
}
type Correspondent = {raw_address:string;display_name?:string;person_id?:string;organisation_id?:string;match_status:string};
/** Collapse repeated addresses without presenting an unconfirmed match as a canonical contact. */
export function conversationCorrespondents(participants:Correspondent[]) {
  const groups = new Map<string,Correspondent[]>();
  for (const item of participants) {
    const key=item.raw_address.trim().toLowerCase();
    if(key)groups.set(key,[...(groups.get(key)??[]),item]);
  }
  return [...groups].map(([address,items])=>{
    const targets = new Set(items.flatMap(i=>i.match_status==='Matched'?[i.person_id?`Person:${i.person_id}`:i.organisation_id?`Organisation:${i.organisation_id}`:'System identity']:[]));
    const confirmed=items.every(i=>i.match_status==='Matched')&&targets.size===1;
    return {address,name:items[0]!.display_name||address,status:confirmed?(items[0]!.person_id?'Existing Person':items[0]!.organisation_id?'Existing organisation':'Recognised address'):items.every(i=>i.match_status==='Rejected')?'Not a contact':targets.size>1?'Conflicting identities — review':'Provisional identity — approval required'};
  });
}
